export enum ApiRoutesProductSets {
  ProductSets = "admin/product-sets",
  Reorder = "reorder"
}
